(function () {
	'use strict';

	// Switching to mobile: https://developer.mozilla.org/en-US/docs/Web/API/MediaQueryList/onchange
	const isMobile = window.matchMedia(
		'(max-width: ' + getComputedStyle(document.body).getPropertyValue('--custom--media-max-width--sm') + ')'
	);
	const navigationResponsiveContainer = document.querySelector(
		'.site-header .wp-block-navigation__responsive-container'
	);
	isMobile.onchange = (e) => {
		if (e.matches) {
			// <= Mobile
		} else {
			// > Mobile
			// Autoclose header nav container if modal is open and browser window gets resized.
			if (
				document.body.contains(navigationResponsiveContainer) &&
				navigationResponsiveContainer.classList.contains('is-menu-open')
			) {
				document.querySelector('.site-header .wp-block-navigation__responsive-container-close').click();
			}
		}
	};

	// Style password protected post form.
	const passwordButton = document.querySelector('.post-password-form [type="submit"]');
	if (document.body.contains(passwordButton)) {
		const passwordButtonWrapper = document.createElement('div');
		passwordButtonWrapper.classList.add('wp-block-button');
		passwordButton.parentNode.insertBefore(passwordButtonWrapper, passwordButton);
		passwordButtonWrapper.appendChild(passwordButton);

		passwordButton.classList.add('wp-block-button__link');
	}

	document.addEventListener('DOMContentLoaded', function() {
    var cursor = document.querySelector('.blob');

		document.addEventListener('mousemove', function(e) {
			var x = e.clientX;
			var y = e.clientY;
			cursor.style.transform = `translate3d(calc(${x}px - 50%), calc(${y}px - 50%), 0)`;
		});
	});



	// Blaze Slider Config
	// document.querySelectorAll('.blaze-slider').forEach(el => {
	//   new BlazeSlider(el, {
	// 	  all: {
	// 	    slidesToShow: 1,
	// 	    slideGap: '200px',
	// 	    loop: true
	// 	  },
	// 	})
	// })
	document.addEventListener('DOMContentLoaded', () => {
            const track = document.querySelector('.blaze-track');
            const slides = Array.from(document.querySelectorAll('.blaze-track .wp-block-group'));
            const prevBtn = document.querySelector('.blaze-prev');
            const nextBtn = document.querySelector('.blaze-next');
            const sliderContainer = document.querySelector('.blaze-container');

            let currentIndex = 0;
            const totalSlides = slides.length;

            // Function to update the slider's position
            const updateSliderPosition = () => {
                // Calculate the vertical offset based on the current slide index and container height
                // The transform property moves the entire track up or down
                const offset = -currentIndex * sliderContainer.clientHeight;
                track.style.transform = `translateY(${offset}px)`;
            };

            // Event listener for the 'Previous' button
            prevBtn.addEventListener('click', () => {
                // Decrement index, loop to last slide if at the beginning
                currentIndex = (currentIndex > 0) ? currentIndex - 1 : totalSlides - 1;
                updateSliderPosition(); // Update slider position
            });

            // Event listener for the 'Next' button
            nextBtn.addEventListener('click', () => {
                // Increment index, loop to first slide if at the end
                currentIndex = (currentIndex < totalSlides - 1) ? currentIndex + 1 : 0;
                updateSliderPosition(); // Update slider position
            });

            // Handle window resize to ensure correct slide positioning
            window.addEventListener('resize', updateSliderPosition);

            // Initial position update when the page loads
            updateSliderPosition();
        });

	// Menu Border fancyness
	// document.addEventListener('DOMContentLoaded', function () {
	// 	const menuItems = document.querySelectorAll('.wp-block-navigation-item .wp-block-navigation-item__content');

	// 	menuItems.forEach((item) => {
	// 		let direction = '';
			
	// 		item.addEventListener('mouseenter', function (event) {
	// 		// Calculate the entry direction of the mouse
	// 		const rect = this.getBoundingClientRect();
	// 		const x = event.clientX - rect.left; // x position within the element.

	// 		if (x < rect.width / 2) {
	// 			direction = 'left';
	// 		} else {
	// 			direction = 'right';
	// 		}
			
	// 		// Remove any existing direction classes
	// 		this.classList.remove('underline-from-left', 'underline-from-right');
			
	// 		// Add the new direction class
	// 		if (direction === 'left') {
	// 			this.classList.add('underline-from-left');
	// 		} else {
	// 			this.classList.add('underline-from-right');
	// 		}
	// 		});

	// 		item.addEventListener('mouseleave', function () {
	// 		// When the mouse leaves, set the transform-origin for the exit animation
	// 		if (direction === 'left') {
	// 			this.classList.remove('underline-from-right');
	// 			this.classList.add('underline-from-left');
	// 		} else {
	// 			this.classList.remove('underline-from-left');
	// 			this.classList.add('underline-from-right');
	// 		}
	// 		});
	// 	});
	// 	});

	document.addEventListener('DOMContentLoaded', function () {
  const navContainer = document.querySelector('header .wp-block-navigation__container');
  const navItems = document.querySelectorAll('header .wp-block-navigation-item');
  
  // We only proceed if there is a navigation container
  if (!navContainer) {
    return;
  }

  // Create the magic line element and add it to the nav
  const magicLine = document.createElement('div');
  magicLine.classList.add('magic-line');
  navContainer.appendChild(magicLine);

  // Find the current menu item (WordPress adds this class)
  const currentItem = document.querySelector('header .wp-block-navigation-item.current-menu-item');
  let activeItem = currentItem;

  // Function to move the line
  function moveLine(item) {
		if (!item) {
		// If no item is active or hovered, hide the line
		magicLine.style.width = '0px';
		return;
		}
		const itemRect = item.getBoundingClientRect();
		const containerRect = navContainer.getBoundingClientRect();
		
		// Calculate position relative to the container
		const leftPosition = itemRect.left - containerRect.left;

		magicLine.style.width = `${itemRect.width}px`;
		magicLine.style.transform = `translateX(${leftPosition}px)`;
	}

	// Set initial position of the line under the current item
	if (activeItem) {
		// A small delay ensures all elements are rendered before we calculate position
		setTimeout(() => {
		moveLine(activeItem);
		}, 100);
	}

	// Add event listeners for hover effect
	navItems.forEach(item => {
		item.addEventListener('mouseenter', () => {
		moveLine(item);
		});
	});

	// When the mouse leaves the entire navigation, move the line back to the active item
	navContainer.addEventListener('mouseleave', () => {
		moveLine(activeItem);
	});
	
	});


	// Appended to your assets/js/main.js file

		/**
		 * Shrinks header and changes its background on scroll.
		 */
		function handleHeaderScroll() {
		const header = document.querySelector('.site-header');
		// Exit if the header element doesn't exist.
		if (!header) {
			return;
		}

		// The scroll distance (in pixels) after which to apply the effect.
		// A value of 50 means the class is added after scrolling 50px down.
		const scrollThreshold = 50;

		// Function to add/remove the 'is-scrolled' class.
		const toggleHeaderClass = () => {
			if (window.scrollY > scrollThreshold) {
			header.classList.add('is-scrolled');
			} else {
			header.classList.remove('is-scrolled');
			}
		};

		// Listen for scroll events on the window.
		window.addEventListener('scroll', toggleHeaderClass, { passive: true });
		
		// Also run the function on page load in case the page is reloaded
		// already scrolled down (e.g., from a refresh).
		toggleHeaderClass();
		}

		// Add the scroll handling logic after the DOM is fully loaded.
		document.addEventListener('DOMContentLoaded', handleHeaderScroll);
		


		document.addEventListener('DOMContentLoaded', function() {
			const imageOverlayContainers = document.querySelectorAll('.image-overlay-container');

			const observerOptions = {
				root: null, // viewport as the root
				rootMargin: '0px',
				threshold: 0.1 // Trigger when 10% of the element is visible
			};

			const observerCallback = (entries, observer) => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						const container = entry.target;
						container.classList.add('in-view'); // Animate the container itself

						// Start the sequential image reveal
						revealImagesSequentially(container);

						observer.unobserve(container); // Stop observing after animation triggers
					}
				});
			};

			const observer = new IntersectionObserver(observerCallback, observerOptions);

			imageOverlayContainers.forEach(container => {
				observer.observe(container);
			});

			// Function to handle the sequential image reveal
			function revealImagesSequentially(container) {
				const imageWrappers = container.querySelectorAll('.overlay-image-wrapper');
				if (imageWrappers.length === 0) {
					return;
				}

				// Set the height of the container based on the first image's aspect ratio
				const firstImage = imageWrappers[0].querySelector('img');
				if (firstImage && firstImage.naturalWidth && firstImage.naturalHeight) {
					const aspectRatio = firstImage.naturalHeight / firstImage.naturalWidth;
					container.style.height = `${container.offsetWidth * aspectRatio}px`;
				} else {
					firstImage.onload = () => {
						const aspectRatio = firstImage.naturalHeight / firstImage.naturalWidth;
						container.style.height = `${container.offsetWidth * aspectRatio}px`;
					};
				}

				// Delay before starting the internal image animations
				const containerAnimationDelay = 600; // Matches container CSS transition
				const imageAnimationStagger = 200;  // Delay between each image animating in (ms)
				const imageAnimationDuration = 400; // Matches image CSS transition

				setTimeout(() => {
					imageWrappers.forEach((wrapper, index) => {
						// Apply a staggered delay for each image
						setTimeout(() => {
							wrapper.classList.add('active');
							// Increase z-index so that subsequent images appear on top
							wrapper.style.zIndex = (index + 2).toString(); // Start from 2 (first image is 2, next is 3, etc.)
						}, index * imageAnimationStagger); // Stagger by index
					});
				}, containerAnimationDelay); // Wait for the container to animate in
			}
		});

		document.addEventListener('DOMContentLoaded', function() {
				const buttons = document.querySelectorAll('.button-ripple-effect .wp-block-button__link');

				buttons.forEach(button => {
					let currentRipple = null; // Stores the currently active ripple element
					let removeTimeoutId = null; // Stores the ID of the setTimeout for ripple removal

					button.addEventListener('mouseenter', function(e) {
						// Clear any pending removal for a previous ripple on this button,
						// which might happen if the mouse quickly re-enters.
						if (removeTimeoutId) {
							clearTimeout(removeTimeoutId);
							removeTimeoutId = null;
						}

						// Remove any existing ripple immediately before creating a new one.
						// This ensures a fresh ripple animation starts each time.
						const existingRipple = this.querySelector('.ripple');
						if (existingRipple) {
							existingRipple.remove();
						}

						const rect = this.getBoundingClientRect();
						const x = e.clientX - rect.left; // X position within the element
						const y = e.clientY - rect.top;  // Y position within the element

						const ripple = document.createElement('span');
						ripple.classList.add('ripple'); // Add the base ripple class
						ripple.style.left = x + 'px';
						ripple.style.top = y + 'px';

						// Calculate the largest dimension to ensure the ripple fully covers the button
						const maxDim = Math.max(rect.width, rect.height);
						ripple.style.width = maxDim * 2 + 'px';
						ripple.style.height = maxDim * 2 + 'px';
						ripple.style.marginLeft = -maxDim + 'px'; // Center horizontally
						ripple.style.marginTop = -maxDim + 'px';   // Center vertically

						this.appendChild(ripple);
						currentRipple = ripple; // Store reference to the newly created ripple

						// A tiny delay with requestAnimationFrame ensures the browser registers
						// the initial state of the ripple before applying the 'ripple-active' class.
						requestAnimationFrame(() => {
							if (currentRipple) { // Ensure the ripple still exists
								currentRipple.classList.add('ripple-active'); // Triggers the expansion and fade-in
							}
						});
					});

					button.addEventListener('mouseleave', function() {
						if (currentRipple) {
							// Remove the 'ripple-active' class. This triggers the ripple to
							// transition back to its initial (hidden) state.
							currentRipple.classList.remove('ripple-active');

							// Set a timeout to remove the ripple element from the DOM *after*
							// its transition (fade-out) completes. This duration should match
							// the `transition` duration in your CSS for the `.ripple` element.
							removeTimeoutId = setTimeout(() => {
								if (currentRipple) { // Check if it still exists before removing
									currentRipple.remove();
									currentRipple = null; // Clear the reference
								}
							}, 600); // Match the CSS transition duration (0.6s = 600ms)
						}
					});
				});
			});



			document.addEventListener('DOMContentLoaded', function () {
				const initVaTabs = (context) => {
					const tabBlocks = context.querySelectorAll('.va-tabs-block:not(.--initialized)');

					tabBlocks.forEach(function (block) {
						const tabLinks = block.querySelectorAll('.va-tab-link');
						const tabContents = block.querySelectorAll('.va-tab-content');

						if (tabLinks.length === 0) return;

						tabLinks.forEach(function (link) {
							link.addEventListener('click', function (event) {
								event.preventDefault();
								const tabId = this.getAttribute('data-tab');

								// Update active state for links
								tabLinks.forEach(l => l.classList.remove('active'));
								this.classList.add('active');

								// Show/hide content panes
								tabContents.forEach(content => {
									if (content.id === tabId) {
										content.classList.add('active');
									} else {
										content.classList.remove('active');
									}
								});
							});
						});
						block.classList.add('--initialized');
					});
				}

				// Initial load
				initVaTabs(document);

				// Support for Gutenberg editor preview
				if (window.acf) {
					window.acf.addAction('render_block_preview', (el) => initVaTabs(el[0]));
				}
			});



			// team-block.js
			document.addEventListener('DOMContentLoaded', function () {
				const allToggleButtons = document.querySelectorAll('.bio-toggle-button');

				allToggleButtons.forEach(button => {
					button.addEventListener('click', function () {
						// Find the parent .team-member container
						const teamMember = this.closest('.team-member');
						
						if (teamMember) {
							// Toggle the 'is-expanded' class on the container
							teamMember.classList.toggle('is-expanded');

							// Get the elements to change inside this specific member card
							const icon = this.querySelector('.plus-minus');
							
							// Check if the card is now expanded and update the button text
							if (teamMember.classList.contains('is-expanded')) {
								this.childNodes[1].nodeValue = ' Hide Bio'; // Changes the text node
								icon.textContent = '−'; // Changes the icon
							} else {
								this.childNodes[1].nodeValue = ' View Bio';
								icon.textContent = '+';
							}
						}
					});
				});
			});


		document.addEventListener('DOMContentLoaded', function() {
		// Find all tab containers on the page
		const allTabsContainers = document.querySelectorAll('.industry-solutions-block');

		allTabsContainers.forEach(function(container) {
			const tabLinks = container.querySelectorAll('.tab-link');
			const tabContents = container.querySelectorAll('.tab-content');

			tabLinks.forEach(function(link) {
				link.addEventListener('click', function(event) {
					event.preventDefault();
					const tabId = this.getAttribute('data-tab');

					// Remove 'active' class from all links and content panels within this container
					tabLinks.forEach(function(innerLink) {
						innerLink.classList.remove('active');
					});
					tabContents.forEach(function(content) {
						content.classList.remove('active');
					});

					// Add 'active' class to the clicked link and its corresponding content
					this.classList.add('active');
					container.querySelector('#' + tabId).classList.add('active');
				});
			});
		});
});


})();
